var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { Button } from '@honeycomb/ui-core';
import { useGlobalContext, useCurrentOpenSearchField, SearchFieldEnum } from '@honeycomb/data';
export function SearchAlternativeDatesButton(_a) {
    var { onOpenSearchUnit } = _a, other = __rest(_a, ["onOpenSearchUnit"]);
    const { resourceStrings: { SEARCHALTDATESBUTTON_CAPTION }, } = useGlobalContext();
    const [_, setOpenField] = useCurrentOpenSearchField();
    const searchNewDates = useCallback(() => {
        setOpenField(SearchFieldEnum.DATES);
        onOpenSearchUnit(true);
    }, [setOpenField, onOpenSearchUnit]);
    return (React.createElement(Button, Object.assign({ size: "l", color: "callToAction", "data-id": "search-alternate", onClick: searchNewDates }, other), SEARCHALTDATESBUTTON_CAPTION));
}
